import { createFileRoute, redirect } from '@tanstack/react-router';

import { legacySettingsSearch, validateLegacyTeamSearch } from '@/pages/settings/settings-tabs';

/**
 * The standalone Workflow Center is gone — workflow config now lives in
 * Team Settings → Workflow (master-detail, no separate page; on a phone the
 * status list editor).  This route redirects any old `/workflows` link there.
 */
export const Route = createFileRoute('/workflows/')({
  validateSearch: validateLegacyTeamSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/settings', search: legacySettingsSearch('workflow', search) });
  },
});
